export default __webpack_public_path__ + "static/media/Import PLWD Template-2.73ec23ee.xlsx";